export default "__VITE_ASSET__BmLnKXaE__"